import { PrimaryButton } from '../../../../../Button/src/tsx/Button';
import { useBookingContext } from '../../contexts/BookingContext';
import { useDate } from '../../hooks/useDate';
import Heading from '../atoms/Heading';
import Container, { Wrapper } from '../organisms/Container';
import DateSelection from '../organisms/DateSelection';
import Navigation from '../organisms/Navigation';
import TimeSelection from '../organisms/TimeSelection';

interface ChangeAppointmentProps {
	getLabel: (key: string) => string;
}

export default function ChangeAppointment({ getLabel }: ChangeAppointmentProps) {
	const { appointment, availability, timezone, settings } = useBookingContext();
	const { date, hasOnlyFullDayTimeSlots, setDate, timeSlots } = useDate({
		availabilities: availability.options,
		setTimeSlot: appointment.setTimeSlot,
		settings,
		timeSlot: appointment.timeSlot,
		timezone: timezone.current,
	});

	const disableSave = appointment.timeSlot === null || availability.isLoading;

	return (
		<Container id="appointment-selection">
			<Wrapper>
				<Heading title={getLabel('booking_heading')} />
				<DateSelection timeSlots={availability.options} getLabel={getLabel} selectedDate={date} setSelectedDate={setDate} />
				{!hasOnlyFullDayTimeSlots && <TimeSelection getLabel={getLabel} timeSlots={timeSlots} />}
			</Wrapper>
			<Navigation keyProp="change-appointment">
				<PrimaryButton onClick={appointment.save} testId="change-appointment" disabled={disableSave}>
					{getLabel('time_slot_selection_accept')}
				</PrimaryButton>
			</Navigation>
		</Container>
	);
}
